$(function(){
  setupSwitcherSingle();
  setupSwitcherMulti();
})

$.fn.svgToggleClass = function(tClass){
  var classList = $(this).attr('class').split(/\s+/);
  var classPos = $.inArray(tClass, classList);

  if(classPos == -1) {classList.push(tClass);}
  else {classList.splice(classPos);}
  var classString = '';
  for (var index = 0; index < classList.length; index++){
    classString += classList[index] + ' ';
  }
  $(this).attr('class', classString);
}

function setupSwitcherSingle(){
  $('.switcher.single').click(function(e, sender){
    
    $('.switcher.single').toggleClass('qwerty');

    $('.connect-switch').each(function(){
      if($(this).prop('tagName').toLowerCase() == 'svg'){ //jQuery is not able to toggle classes of svg elements in this version
        $(this).svgToggleClass('qwerty');
      }
      else {$(this).toggleClass('qwerty');}
    });

    // and save using ajax
    var currentValue = $(this).attr('data-currentValue');
    var possibleValues = $(this).attr('data-possibleValues').split(',');

    // this can be easily generalized for more options (more keyboards in the future)
    if (currentValue == possibleValues[0])
      currentValue = possibleValues[1];
    else currentValue = possibleValues[0];

    if(currentValue.indexOf("qwertz") >= 0) 
    {
      $('.keyboard-svg').removeClass('qwerty');
      $('.keyboard-svg').addClass('qwertz');
    } 
    else if (currentValue.indexOf("qwerty") >= 0)
    {
      $('.keyboard-svg').removeClass('qwertz');
      $('.keyboard-svg').addClass('qwerty');
    }


    $(this).attr('data-currentValue', currentValue);

    $.post(baseUrl+'/player/save-keyboard-type', {'keyboardType': currentValue});
  });

}

function setupSwitcherMulti(){
  $('.switcher.multi').click(function(){
    var $thisEl = $(this);
    $('.switcher.multi').each(function(){
      if($(this).data('group') == $thisEl.data('group')) $(this).removeClass('active');
    });
    $thisEl.addClass('active');
  });
}
